import type { DatePickerPreset } from "@mantine/dates";
import dayjs from "dayjs";

export function convertToDateTimeString(date: string) {
  const day = dayjs(date);
  return day.format("DD. MMMM YYYY HH:mm");
}

export function convertToTimeString(date?: string) {
  if (!date) {
    return undefined;
  }
  const day = dayjs(date);
  return day.format("YYYY-MM-DD HH:mm:ss");
}

export function convertToUTCTimeString(date?: string) {
  if (!date) {
    return undefined;
  }
  const day = dayjs(date);
  return day.utc().format("YYYY-MM-DD HH:mm:ss");
}

export function convertToDateString(date: string) {
  const day = dayjs(date);
  return day.utc().format("DD.MM.YYYY");
}

export function rangePresets(): DatePickerPreset<"range">[] {
  const format = "YYYY-MM-DD";
  const today = dayjs();
  const ranges: DatePickerPreset<"range">[] = [
    {
      value: [today.startOf("week").format(format), today.endOf("week").format(format)],
      label: "Diese Woche",
    },
    {
      value: [today.subtract(1, "week").startOf("week").format(format), today.subtract(1, "week").endOf("week").format(format)],
      label: "Letzte Woche",
    },
    {
      value: [today.startOf("month").format(format), today.endOf("month").format(format)],
      label: "Diesen Monat",
    },
    {
      value: [today.subtract(1, "month").startOf("month").format(format), today.subtract(1, "month").endOf("month").format(format)],
      label: "Letzten Monat",
    },
    {
      value: [today.startOf("year").format(format), today.endOf("year").format(format)],
      label: "Dieses Jahr",
    },
    {
      value: [today.subtract(1, "year").startOf("year").format(format), today.subtract(1, "year").endOf("year").format(format)],
      label: "Letztes Jahr",
    },
  ];

  return ranges;
}
